<template>
  <div class="notification-config-modal">
    <el-dialog
      :visible.sync="dialogVisible"
      :title="$t('system.notification_config')"
      class="diglog-card"
      :close-on-click-modal="false"
      width="850px"
      append-to-body
    >
      <div v-loading="dialogLoading" class="modal-body">
        <!-- User Info Section -->
        <!-- <div class="user-info-card">
          <div class="info-row">
            <span class="info-label">{{ $t('system.username') }}:</span>
            <span class="info-value">{{ userInfo.username }}</span>
          </div>
          <div class="info-row">
            <span class="info-label">{{ $t('system.login_email') }}:</span>
            <span class="info-value">{{ userInfo.email }}</span>
          </div>
        </div> -->

        <!-- Notification Types Section -->
        <div class="notification-list">
          <div
            v-for="type in notificationTypes"
            :key="type.value"
            class="notification-item"
          >
            <div class="item-main">
              <div class="item-left">
                <div class="item-title">{{ type.label }}</div>
                <div class="item-desc">{{ type.description }}</div>
              </div>
              <div class="item-right">
                <span class="receive-label">{{ $t('system.receive_notification') }}</span>
                <el-switch
                  :value="isTypeSelected(type.value)"
                  @change="toggleType(type.value, $event)"
                />
              </div>
            </div>
            <div v-if="type.value === 5 && userInfo.account_type === 1" class="item-extra">
              <div class="warn-amount-section">
                <div
                  v-for="(item, index) in warnAmountList"
                  :key="index"
                  :class="['warn-amount-row', { 'has-error': duplicateErrors[index] }]"
                >
                  <span v-if="index === 0" class="warn-amount-label">{{ $t('system.warn_amount') }}:</span>
                  <span v-else class="warn-amount-label-placeholder" />
                  <div class="warn-amount-field">
                    <el-input
                      v-model="item.value"
                      class="warn-amount-input"
                      :placeholder="$t('system.warn_amount_placeholder')"
                      size="small"
                      :disabled="!isEditingWarnAmount"
                      @input="handleWarnAmountInput($event, item)"
                      @blur="handleWarnAmountBlur(item, index)"
                    />
                    <i
                      v-if="isEditingWarnAmount"
                      class="el-icon-circle-close delete-icon"
                      @click="removeWarnAmountRow(index)"
                    />
                    <div v-if="duplicateErrors[index]" class="warn-amount-error">{{ duplicateErrors[index] }}</div>
                    <div v-if="rangeErrors[index]" class="warn-amount-error">{{ rangeErrors[index] }}</div>
                  </div>
                  <template v-if="index === warnAmountList.length - 1">
                    <el-button
                      v-if="!isEditingWarnAmount"
                      type="primary"
                      size="mini"
                      @click="editWarnAmount"
                    >{{ $t('components.edit') }}</el-button>
                    <template v-else>
                      <el-button
                        v-if="warnAmountList.length < 3"
                        class="add-warn-btn"
                        @click="addWarnAmountRow"
                      >{{ $t('system.add_warn_amount') }}</el-button>
                      <el-button type="primary" size="small" @click="saveWarnAmount(index)">{{ $t('system.save') }}</el-button>
                      <el-button size="small" @click="cancelWarnAmount">{{ $t('components.cancel') }}</el-button>
                    </template>
                  </template>
                </div>
              </div>
              <div
                class="test-link"
                @click.stop="sendTestNotification"
              >
                {{ $t('system.send_test_notification') }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{ $t('components.cancel') }}</el-button>
        <el-button type="primary" :loading="listLoading" @click="submitConfig">{{ $t('components.confirm') }}</el-button>
      </span> -->
    </el-dialog>
  </div>
</template>

<script>
import { fetchNoticeSetting, updateNoticeSetting, updateNoticeBalanceWarnAmount, sendTestNotice } from '@/api/system/system'

export default {
  name: 'NotificationConfigModal',
  data() {
    return {
      dialogVisible: false,
      listLoading: false,
      dialogLoading: false,
      userId: 0,
      userInfo: {
        username: '',
        email: '',
        account_type: 2
      },
      configForm: {
        selectedTypes: []
      },
      warnAmountList: [{ value: '' }],
      warnAmountSnapshot: [],
      duplicateErrors: {},
      rangeErrors: {},
      isEditingWarnAmount: false
    }
  },
  computed: {
    notificationTypes() {
      const isPrimaryAccount = this.userInfo.account_type === 1
      const balanceAlertDesc = isPrimaryAccount
        ? this.$t('map.template_type_5_desc')
        : this.$t('map.template_type_5_desc_sub')
      return [
        { value: 5, label: this.$t('map.template_type_5'), description: balanceAlertDesc },
        { value: 1, label: this.$t('map.template_type_1'), description: this.$t('map.template_type_1_desc') },
        { value: 2, label: this.$t('map.template_type_2'), description: this.$t('map.template_type_2_desc') },
        { value: 3, label: this.$t('map.template_type_3'), description: this.$t('map.template_type_3_desc') },
        // { value: 6, label: this.$t('map.template_type_6'), description: this.$t('map.template_type_6_desc') },
        { value: 4, label: this.$t('map.template_type_4'), description: this.$t('map.template_type_4_desc') },
        { value: 99, label: this.$t('map.template_type_99'), description: this.$t('map.template_type_99_desc') }
      ]
    }
  },
  watch: {
    warnAmountList: {
      handler() {
        if (this.isEditingWarnAmount) {
          this.checkDuplicateWarnAmount()
        }
      },
      deep: true
    }
  },
  mounted() {
    this.$bus.off('SHOW_NOTIFICATION_CONFIG_MODAL')
    this.$bus.on('SHOW_NOTIFICATION_CONFIG_MODAL', (value) => {
      const [visible, row] = value
      this.dialogVisible = visible
      this.isEditingWarnAmount = false
      if (row) {
        this.userId = row.id
        this.userInfo.username = row.username
        this.userInfo.email = row.email
        this.userInfo.account_type = row.account_type || 2
        this.loadUserNotificationConfig(row.id)
      }
    })
  },
  methods: {
    loadUserNotificationConfig(userId) {
      this.dialogLoading = true
      fetchNoticeSetting({ merchant_user_id: userId }).then(res => {
        if (res.code === 10000) {
          const d = res.data || {}
          this.configForm.selectedTypes = []
          const switchMap = {
            maintain_switch: 1,
            holiday_switch: 2,
            risk_order_switch: 3,
            fee_rate_switch: 4,
            balance_warn_switch: 5,
            dispute_switch: 6,
            other_switch: 99
          }
          Object.keys(switchMap).forEach(key => {
            if (d[key] === 2) {
              this.configForm.selectedTypes.push(switchMap[key])
            }
          })
          // Parse warnAmountList for balance alert
          if (d.warn_amount_list && d.warn_amount_list.length > 0) {
            this.warnAmountList = d.warn_amount_list.map(amount => ({ value: String(amount / 100) }))
          } else {
            this.warnAmountList = [{ value: '' }]
          }
        }
      }).catch(() => {
        this.configForm.selectedTypes = []
      }).finally(() => {
        this.dialogLoading = false
      })
    },
    sendTestNotification() {
      sendTestNotice({ merchant_user_id: this.userId }).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
        } else {
          this.$message.warning(res.msg || 'Failed')
        }
      }).catch(() => {
        this.$message.error('Error')
      })
    },
    addWarnAmountRow() {
      this.warnAmountList.push({ value: '' })
    },
    removeWarnAmountRow(index) {
      if (this.warnAmountList.length <= 1) {
        this.warnAmountList[index].value = ''
      } else {
        this.warnAmountList.splice(index, 1)
      }
    },
    handleWarnAmountInput(val, item) {
      const strVal = String(val)
      let formatted = strVal.replace(/[^0-9.]/g, '')
      const dotIndex = formatted.indexOf('.')
      if (dotIndex !== -1) {
        formatted = formatted.slice(0, dotIndex + 3)
      }
      item.value = formatted
    },
    handleWarnAmountBlur(item, index) {
      const errors = { ...this.rangeErrors }
      delete errors[index]
      if (item.value === '') {
        this.rangeErrors = errors
        return
      }
      const num = parseFloat(item.value)
      if (isNaN(num) || num <= 0) {
        errors[index] = this.$t('system.warn_amount_min_error')
        this.rangeErrors = errors
        return
      }
      if (num > 999999999999) {
        errors[index] = this.$t('system.warn_amount_max_error')
        this.rangeErrors = errors
        return
      }
      item.value = num.toFixed(2)
      this.rangeErrors = errors
    },
    editWarnAmount() {
      this.warnAmountSnapshot = JSON.parse(JSON.stringify(this.warnAmountList))
      this.duplicateErrors = {}
      this.isEditingWarnAmount = true
    },
    checkDuplicateWarnAmount() {
      const errors = {}
      const seen = {}
      for (let i = 0; i < this.warnAmountList.length; i++) {
        const val = parseFloat(this.warnAmountList[i].value)
        if (isNaN(val) || val < 0) {
          continue
        }
        if (seen[val] !== undefined) {
          errors[i] = this.$t('system.warn_amount_duplicate')
        }
        seen[val] = i
      }
      this.duplicateErrors = errors
      return Object.keys(errors).length === 0
    },
    validateAllRange() {
      const errors = {}
      let hasError = false
      for (let i = 0; i < this.warnAmountList.length; i++) {
        const item = this.warnAmountList[i]
        if (item.value === '') {
          continue
        }
        const num = parseFloat(item.value)
        if (isNaN(num) || num <= 0) {
          errors[i] = this.$t('system.warn_amount_min_error')
          hasError = true
          continue
        }
        if (num > 999999999999) {
          errors[i] = this.$t('system.warn_amount_max_error')
          hasError = true
          continue
        }
      }
      this.rangeErrors = errors
      return !hasError
    },
    saveWarnAmount(index) {
      const rangeValid = this.validateAllRange()
      if (!rangeValid) {
        return
      }
      if (!this.checkDuplicateWarnAmount()) {
        return
      }
      const amounts = this.warnAmountList
        .map(item => parseFloat(item.value))
        .filter(n => !isNaN(n) && n >= 0)
        .map(n => Math.round(n * 100))
      updateNoticeBalanceWarnAmount({ merchant_user_id: this.userId, warn_amount_list: amounts }).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          this.isEditingWarnAmount = false
          this.loadUserNotificationConfig(this.userId)
        }
      })
    },
    cancelWarnAmount() {
      this.warnAmountList = this.warnAmountSnapshot
      this.duplicateErrors = {}
      this.isEditingWarnAmount = false
    },
    isTypeSelected(typeValue) {
      return this.configForm.selectedTypes.includes(typeValue)
    },
    toggleType(typeValue, checked) {
      if (checked) {
        if (!this.configForm.selectedTypes.includes(typeValue)) {
          this.configForm.selectedTypes.push(typeValue)
        }
      } else {
        const index = this.configForm.selectedTypes.indexOf(typeValue)
        if (index > -1) {
          this.configForm.selectedTypes.splice(index, 1)
        }
      }
      this.updateNoticeSetting()
    },
    updateNoticeSetting() {
      const params = {
        merchant_user_id: this.userId,
        maintain_switch: this.configForm.selectedTypes.includes(1) ? 2 : 1,
        holiday_switch: this.configForm.selectedTypes.includes(2) ? 2 : 1,
        risk_order_switch: this.configForm.selectedTypes.includes(3) ? 2 : 1,
        fee_rate_switch: this.configForm.selectedTypes.includes(4) ? 2 : 1,
        balance_warn_switch: this.configForm.selectedTypes.includes(5) ? 2 : 1,
        dispute_switch: this.configForm.selectedTypes.includes(6) ? 2 : 1,
        other_switch: this.configForm.selectedTypes.includes(99) ? 2 : 1
      }
      this.dialogLoading = true
      updateNoticeSetting(params).then(res => {
        if (res.code === 10000) {
          this.$message.success('Success')
          // Re-fetch to ensure data consistency
          this.loadUserNotificationConfig(this.userId)
        }
      }).catch(() => {
        this.dialogLoading = false
      })
    },
    submitConfig() {
      this.listLoading = true
      // TODO: Call API to save notification config
      // params: { user_id: this.userId, template_types: this.configForm.selectedTypes }

      setTimeout(() => {
        this.listLoading = false
        this.dialogVisible = false
        this.$message.success('Success')
      }, 500)
    }
  }
}
</script>

<style scoped lang="scss">
.notification-config-modal {
  ::v-deep .el-dialog__body {
    padding: 20px;
  }
  ::v-deep .el-dialog__header {
    padding: 16px 20px;
    border-bottom: 1px solid #E3E3E3;
  }
  ::v-deep .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #333333;
  }
  ::v-deep .el-dialog__footer {
    padding: 16px 20px;
    border-top: 1px solid #E3E3E3;
  }
}

.modal-body {
  padding: 10px 0;
}

.user-info-card {
  background: #F8F8F8;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 20px;
}

.info-row {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
  }
}

.info-label {
  min-width: 80px;
  color: #666666;
  font-size: 12px;
}

.info-value {
  color: #333333;
  font-size: 14px;
  font-weight: 500;
}

.notification-list {
  display: block;
}

.notification-item {
  display: flex;
  flex-direction: column;
  background: #FFFFFF;
  border: 1px solid #E3E3E3;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 12px;
  transition: border-color 0.2s;

  &:hover {
    border-color: #D9D9D9;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.item-main {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.item-extra {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #F0F0F0;
}

.item-left {
  flex: 1;
  padding-right: 16px;
}

.item-title {
  font-size: 14px;
  font-weight: 600;
  color: #333333;
  margin-bottom: 4px;
}

.item-desc {
  font-size: 12px;
  color: #999999;
  line-height: 1.5;
  word-break: keep-all;
  overflow-wrap: break-word;
}

.warn-amount-section {
  margin-top: 10px;
}

.warn-amount-row {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-bottom: 8px;
  &.has-error {
    margin-bottom: 28px;
  }
  &:last-child {
    margin-bottom: 0;
  }
}

.warn-amount-label {
  width: 114px;
  font-size: 12px;
  color: #666666;
  white-space: nowrap;
  flex-shrink: 0;
}

.warn-amount-label-placeholder {
  width: 114px;
  flex-shrink: 0;
}

.warn-amount-input {
  width: 220px;
  ::v-deep .el-input__inner {
    padding-right: 0;
  }
}

.delete-icon {
  font-size: 16px;
  color: #C0C4CC;
  cursor: pointer;
  flex-shrink: 0;
  &:hover {
    color: #F56C6C;
  }
}

.warn-amount-field {
  display: flex;
  align-items: center;
  gap: 4px;
}

.warn-amount-error {
  font-size: 12px;
  color: #F56C6C;
  position: absolute;
  left: 0;
  bottom: -16px;
  white-space: nowrap;
}

.warn-amount-field {
  position: relative;
}

.add-warn-btn {
  padding: 0;
  border: none;
  background: none;
  color: #1890FF;
  font-size: 12px;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
  i {
    margin-right: 2px;
  }
}

.test-link {
  font-size: 12px;
  color: #1890FF;
  cursor: pointer;
  text-decoration: none;
  text-align: right;
  word-break: break-word;

  &:hover {
    text-decoration: underline;
  }
}

.item-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}

.item-right-top {
  display: flex;
  align-items: center;
  gap: 8px;
}

.receive-label {
  font-size: 12px;
  color: #666666;
  white-space: nowrap;
}
</style>
